import { memo, useCallback } from 'react';

import { ConnectedChainCard } from '@Components/ConnectedChainCard';
import { CredentialEntry } from '../credentials.types';

interface CredentialCardProps {
  entry: CredentialEntry;
  isInfoOpen: boolean;
  toggleInfo: (id: string) => void;
}

const CredentialCard = memo(({ entry: { card, id }, isInfoOpen, toggleInfo }: CredentialCardProps) => {
  const handleToggleInfo = useCallback(() => toggleInfo(id), [toggleInfo, id]);
  return <ConnectedChainCard {...card} isInfoOpen={isInfoOpen} onToggleInfo={handleToggleInfo} />;
});

CredentialCard.displayName = 'CredentialCard';
export default CredentialCard;
